import { render, staticRenderFns } from "./LegacyManageMenuItemForm.vue?vue&type=template&id=2f1be2e4&"
import script from "./LegacyManageMenuItemForm.vue?vue&type=script&lang=js&"
export * from "./LegacyManageMenuItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports